import { render } from "./ImpostazioniView.vue?vue&type=template&id=6ea53dc0"
import script from "./ImpostazioniView.vue?vue&type=script&lang=js"
export * from "./ImpostazioniView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__